// extracted by mini-css-extract-plugin
module.exports = {"content":"CardsWithIcon_content__uO5Ad","card":"CardsWithIcon_card__rU0fG","iconContainer":"CardsWithIcon_iconContainer__Heoah"};